import React from 'react';
import {Helmet} from "react-helmet";

const PageNotFound = () => (
    <React.Fragment>
        <Helmet>
            <meta name="prerender-status-code" content="404"/>
        </Helmet>
        <div className="pageNotFound">
            <div className="container" style={{textAlign: 'center', marginTop: '10vh', marginBottom: '50vh'}}>
                <h1>404</h1>
            </div>
        </div>
    </React.Fragment>
);

export default PageNotFound;



// WEBPACK FOOTER //
// ./frontend/pages/404/404.jsx